import React, { PureComponent } from 'react';

import View from '@zego/components/atoms/View';

import SegmentedChoiceButton from './SegmentedChoiceButton';

const isChecked = (value, choice) => {
  if (value === undefined) {
    return undefined;
  }
  return value === choice.value;
};

class SegmentedChoiceInput extends PureComponent {
  render() {
    const { name, value, choices, onChange } = this.props;

    return (
      <View css={{ width: '100%', display: 'flex' }}>
        {choices.map((choice, index) => (
          <SegmentedChoiceButton
            key={choice.value}
            name={name}
            label={choice.label}
            value={choice.value}
            onChange={onChange}
            checked={isChecked(value, choice)}
            numChoices={choices.length}
            isFirst={index === 0}
            isLast={index === choices.length - 1}
          />
        ))}
      </View>
    );
  }
}

export default SegmentedChoiceInput;
